import React from 'react';
// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import Autocomplete from '@mui/material/Autocomplete';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import './SearchSuggest.css';
// import { withStyles } from "@material-ui/core/styles";
import { memoize } from 'lodash';

// const ValidationTextField = withStyles({
//   root: {
//     "& input:valid + fieldset": {
//       borderColor: "#2B8000"
//     }
//   }
// })(TextField);
const ValidationTextField = styled(TextField)(({ theme }) => ({
  '& input:valid + fieldset': {
    borderColor: '#2B8000',
  },
}));

export default function SearchSuggest(props) {
  const [value, setValue] = React.useState(props.initialValue||null);

  const memoizedFilterFunc = memoize((options, params) => {
    if(params.inputValue.length >= props.minCharToStartSearch){
    const filtered = [];
    const noOfOptionToShow = props.noOfOptionToConsider || props.dataList.length;
   
    let matchCount = 0;
    for (let i = 0; i < props.dataList.length; i++) {
      if (matchCount === noOfOptionToShow) { break; }
      if(props.dataList[i].dataValue.toLowerCase().indexOf(params.inputValue.toLowerCase()) >= 0) {
        filtered.push(props.dataList[i]);
        matchCount++;
      }
    }

    return filtered;}
    else {
      return [{
        "dataID": "A1",
        "dataValue": "Loading...."
      }]
    }
    
  }, (...args) => {
    return args[1].inputValue;
  });


  return (
    <React.Fragment>
    <Autocomplete
      value={value}
      data-testid="autocomplete"
      onChange={(event, newValue) => {
          setValue(newValue);
          props.searchHandler(newValue, props.index);
      }}
      filterOptions={memoizedFilterFunc}
      isOptionEqualToValue={(option, value) => option.dataValue === value.dataValue}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id="free-solo-with-text-demo"
      options={props.dataList}
      getOptionDisabled={(option) => {
        if(option.dataValue === "Loading...."){
        return true;
        } else{
          return false;
        }
      }}
      getOptionLabel={(option) => {
        // Value selected with enter, right from the input
        if (typeof option === 'string') {
          return option;
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
          return option.inputValue;
        }
        // Regular option
        return option.dataValue;
      }}
      forcePopupIcon={false}
      disablePortal={true}
      renderOption={(props, option) => (
        <li {...props}>{option.dataValue}</li>
      )}
      renderInput={(params) => (
        <ValidationTextField {...params} 
          required
          error = {(props.haveError==="true"&&value === null)? true : false}
          id="outlined-required"
          size="small"
          label={props.label}
          placeholder={props.placeholder}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          onKeyDown={(e)=> e.key==='Enter'? e.preventDefault(): null}
          />)
      }
    />
    {value==null&&<FontAwesomeIcon className="searchIconSuggest" icon={faSearch} />}
    </React.Fragment>
  );
}